/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.ItemDetailsLayout.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.ItemDetailsLayout.View", ["require", "exports", "SuiteCommerce.PagePrinter.PrintableLayout.PrintableLayout.View", "SuiteCommerce.PagePrinter.Item.Collection", "SuiteCommerce.PagePrinter.ItemDetailsLayout.ItemDetailsLayout.Item.View", "SuiteCommerce.PagePrinter.EmptyState.EmptyState.ItemNotFound.View", "SuiteCommerce.PagePrinter.EmptyState.EmptyState.Model", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Configuration", "Backbone", "SuiteCommerce.PagePrinter.Common.Configuration", "SuiteCommerce.PagePrinter.Instrumentation", "SuiteCommerce.PagePrinter.Common.Utils"], function (require, exports, PrintableLayout_View_1, Item_Collection_1, ItemDetailsLayout_Item_View_1, EmptyState_ItemNotFound_View_1, EmptyState_Model_1, ItemDetailsLayout_Configuration_1, Backbone_1, Configuration_1, Instrumentation_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PrintItemDetailsURL = 'print-item-details';
    var ItemDetailsLayoutView = /** @class */ (function (_super) {
        __extends(ItemDetailsLayoutView, _super);
        function ItemDetailsLayoutView(options) {
            var _this = _super.call(this, options) || this;
            _this.container = options.container;
            _this.environment = _this.container.getComponent('Environment');
            _this.initializePrintableView(options);
            return _this;
        }
        ItemDetailsLayoutView.prototype.beforeShowContent = function () {
            var _this = this;
            var promise = jQuery.Deferred();
            if (Configuration_1.Configuration.isRunningInSEO()) {
                promise.resolve();
            }
            else {
                var logLoaderRequest_1 = Instrumentation_1.default.getLog('timeToLoadItemDetailsPage');
                logLoaderRequest_1.startTimer();
                var fetchItemCollection_1 = function () {
                    _this.collection.fetch().done(function () {
                        if (_this.collection.size() > 0) {
                            logLoaderRequest_1.endTimer();
                            logLoaderRequest_1.setParameters({
                                activity: 'Time it takes to load the item details page',
                                totalTime: logLoaderRequest_1.getElapsedTimeForTimer(),
                            });
                            logLoaderRequest_1.submit();
                            _this.model = _this.collection.at(0);
                            if (_this.model.isMatrixChild) {
                                promise.reject();
                                Backbone_1.history.navigate(PrintItemDetailsURL + "/" + _this.model.parentId, { trigger: true, replace: true });
                            }
                            else {
                                _this.printableView = new ItemDetailsLayout_Item_View_1.ItemDetailsItemView({
                                    model: _this.model,
                                });
                                _this.title = "Print - " + _this.model.name;
                                _this.metaDescription = "" + _this.model.name;
                                promise.resolve();
                            }
                        }
                        else {
                            var layout = _this.container.getComponent('Layout');
                            layout.showContent(new EmptyState_ItemNotFound_View_1.EmptyStateItemNotFoundView({
                                model: new EmptyState_Model_1.EmptyStateModel({
                                    message: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.itemNotFoundMessage,
                                    buttonLabel: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.continueShoppingButtonLabel,
                                }),
                            }));
                            promise.reject();
                        }
                    });
                };
                if (Utils_1.Utils.userProfileData) {
                    fetchItemCollection_1();
                }
                else {
                    var userProfile = this.container.getComponent('UserProfile');
                    userProfile
                        .getUserProfile()
                        .then(function (userProfileData) {
                        Utils_1.Utils.userProfileData = userProfileData;
                        fetchItemCollection_1();
                    });
                }
            }
            return promise;
        };
        ItemDetailsLayoutView.prototype.initializePrintableView = function (options) {
            this.collection = new Item_Collection_1.ItemCollection({
                environment: this.environment,
                ids: [options.routerArguments[0]],
            });
        };
        return ItemDetailsLayoutView;
    }(PrintableLayout_View_1.PrintableLayoutView));
    exports.ItemDetailsLayoutView = ItemDetailsLayoutView;
});
